
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "MonetizationSection",
  props: {
    monetization: { type: Object, required: true },
    loading: { type: Boolean, default: false },
    loaded: { type: Boolean, default: false },
    error: { type: String, default: null },
  },
  setup(props) {
    // arpu is null when the active-user denominator is 0 — the activity bitmaps
    // don't cover this range, so the value is unknown, not zero. Em dash, never
    // "0.000". Same convention as RetentionSection's formatRate. ARPPU keeps a
    // plain number: its denominator is the SQL payer count, so 0 there is genuine.
    const formatAmount = (v: number | null | undefined, digits: number) =>
      v === null || v === undefined ? "—" : v.toFixed(digits);

    const series = computed(() => [
      { name: "Revenue", data: (props.monetization.revenue ?? []).map((p: any) => p.value) },
    ]);
    const chartOptions = computed(() => ({
      chart: { toolbar: { show: false }, background: "transparent" },
      stroke: { curve: "smooth", width: 2 },
      xaxis: {
        categories: (props.monetization.revenue ?? []).map((p: any) => p.date.slice(0, 10)),
        labels: { style: { colors: "#fff" } },
      },
      yaxis: { labels: { style: { colors: "#fff" } } },
      tooltip: { theme: "dark" },
      dataLabels: { enabled: false },
      colors: ["#4CAF50"],
    }));
    return { series, chartOptions, formatAmount };
  },
});
